import React, {useEffect, useState} from 'react';
import {Grid, Segment, Header, Icon, Label, Placeholder} from "semantic-ui-react";
import {Redirect, useParams} from "react-router-dom";
import { format } from 'date-fns';
import store from "../components/hoc/store";
import Seo from "../components/Seo";
import WinnersFeed from "../components/WinnersFeed";
import {FormattedMessage} from "react-intl";
import {createUrl} from "../utils/urlManager";

const Certificate = ({ store }) => {
	const [loading, setLoading] = useState(true);
	const [draw, setDraw] = useState({});
	const { alias, lang } = useParams();

	useEffect(() => {
		setLoading(true);
		store.findAll('announcements', {
			params: {
				'filter[alias]': alias
			}
		})
			.then(announcements => announcements.data.length > 0 ? announcements.data[0] : {})
			.then(announcement => {
				if (!announcement.id) {
					setDraw(null);
					return;
				}
				return announcement.related('draw')
					.then(drw => setDraw(drw));
			})
			.then(() => setLoading(false))
	}, [alias, store]);

	if (!draw) {
		return <Redirect to={createUrl('/404', {}, lang)}/>
	}

	const { winners, createdAt, participantsCount } = draw;
	return (
		<>
			<Seo
				title={`Arbitery - Certificate of Validity #${alias}`}
				description=""
			/>
			<Grid columns={1} centered className="grey-background">
				<Grid.Column textAlign="bottom">
					<Icon name="medal" size="huge" />
				</Grid.Column>
				<Grid.Column mobile={14} tablet={8} computer={8}>
					{loading && (
						<Segment.Group>
							<Segment padded attached="top">
								<Grid columns={2}>
									<Grid.Column>
										<Placeholder>
											<Placeholder.Line />
											<Placeholder.Line />
										</Placeholder>
									</Grid.Column>
									<Grid.Column>
										<Placeholder>
											<Placeholder.Line />
											<Placeholder.Line />
										</Placeholder>
									</Grid.Column>
								</Grid>
							</Segment>
							<Segment padded attached="bottom">
								<Placeholder>
									<Placeholder.Header image>
										<Placeholder.Line />
										<Placeholder.Line />
									</Placeholder.Header>
								</Placeholder>
							</Segment>
						</Segment.Group>
					)}
					{!loading && (
						<Segment.Group raised>
							<Segment padded attached='top'>
								<Grid columns={2} stackable>
									<Grid.Column>
										<FormattedMessage id="certificate.id.title" defaultMessage="Certificate ID" />
										<Header as="h3" className="mt-1">{alias}</Header>
									</Grid.Column>
									<Grid.Column>
										<div className="mb-2">
											<FormattedMessage id="certificate.date.title" defaultMessage="Date" />: <b>{createdAt && format(new Date(createdAt * 1000), 'MMMM DD, YYYY H:mm')}</b>
										</div>
										<div>
											<FormattedMessage id="certificate.participants.title" defaultMessage="Participants" />: <b>{participantsCount || 'N/A'}</b>
										</div>
									</Grid.Column>
								</Grid>
							</Segment>
							<Segment padded attached="bottom">
								<Header as="h3">Winners <Label icon="check" basic color="green" content="Verified" /></Header>
								<WinnersFeed winners={winners}/>
							</Segment>
						</Segment.Group>
					)}
					<div className="text-center">
						<small>The winners are selected using a true random number generator and verified as compliant with the rules by <a href="https://arbitery.com">Arbitery</a></small>
					</div>
				</Grid.Column>
			</Grid>
		</>
	)

}

export default store(Certificate);
